import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const Partners = ({ onChange, data = [], view = false }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const [partnerList, setPartnerList] = useState(data);

  const onSubmit = (data) => {
    let obj = [...partnerList];
    obj.push(data);
    setPartnerList(obj);
    onChange(obj);
    reset();
  };

  const handleDelete = (key) => {
    let obj = [...partnerList];
    obj.splice(key, 1);
    setPartnerList(obj);
    onChange(obj);
  };

  return (
    <div>
      <form key={"Partners"} autocomplete="off">
        <div className="card-header mt-3">
          Identificación de asociados o accionistas, aporte o participación (si
          requiere más espacio anexe relación)
        </div>
        <div className="table-responsive">
          <table class="table table-bordered mt-3">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">No. ID</th>
                <th scope="col">NOMBRE Y APELLIDO</th>
                <th scope="col">
                  ¿Por su actividad o cargo administra recursos públicos?
                </th>
                <th scope="col">
                  ¿Por su actividad o cargo ejerce algún grado de poder público?
                </th>
                <th scope="col">
                  ¿Por su actividad o cargo goza de reconocimiento público?
                </th>
                <th scope="col">
                  ¿Esta obligado a declaración tributaria en otros país/es ?
                  ¿Cuáles?
                </th>
                {!view && <th scope="col"></th>}
              </tr>
            </thead>
            <tbody>
              {partnerList && partnerList.length > 0 ? (
                partnerList.map((ele, key) => (
                  <>
                    <tr>
                      <td>{key + 1}</td>
                      <td>{ele.numero_documento}</td>
                      <td>{ele.nombre_apellidos}</td>
                      <td>{ele.recursos_publicos}</td>
                      <td>{ele.poder_publico}</td>
                      <td>{ele.reconocimiento_publico}</td>
                      <td>{ele.declaracion_tributaria}</td>
                      {!view && (
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            type="button"
                            onClick={(e) => handleDelete(key)}
                          >
                            <i className="fas fa-times-circle fa-xs"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  </>
                ))
              ) : (
                <>
                  <tr>
                    <td
                      className="text-center"
                      scope="col"
                      colspan={view ? 7 : 8}
                    >
                      <span>No record found.</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        {!view && (
          <>
            <div className="row mt-3">
              <div className="form-group col-md-3">
                <label className="form-label">No. ID</label>
                <input
                  style={{ textTransform: "uppercase" }}
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  className="form-control form-control-user"
                  name="numero_documento"
                  {...register("numero_documento", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label">NOMBRE Y APELLIDO </label>
                <input
                  style={{ textTransform: "uppercase" }}
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  className="form-control form-control-user"
                  name="nombre_apellidos"
                  {...register("nombre_apellidos", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label">
                  ¿Por su actividad o cargo administra recursos públicos?{" "}
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"SI"}
                    name="recursos_publicos"
                    {...register("recursos_publicos", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">SI</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"NO"}
                    name="recursos_publicos"
                    {...register("recursos_publicos", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">NO</label>
                </div>
              </div>
              <div className="form-group col-md-3">
                <label className="form-label">
                  ¿Por su actividad o cargo ejerce algún grado de poder público?{" "}
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"SI"}
                    name="poder_publico"
                    {...register("poder_publico", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">SI</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"NO"}
                    name="poder_publico"
                    {...register("poder_publico", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">NO</label>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="form-group col-md-3">
                <label className="form-label">
                  ¿Por su actividad o cargo goza de reconocimiento público?{" "}
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"SI"}
                    name="reconocimiento_publico"
                    {...register("reconocimiento_publico", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">SI</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"NO"}
                    name="reconocimiento_publico"
                    {...register("reconocimiento_publico", {
                      required: true,
                    })}
                  />
                  <label className="form-check-label">NO</label>
                </div>
              </div>
              <div className="form-group col-md-3">
                <label className="form-label">
                  ¿Esta obligado a declaración tributaria en otros país/es ?
                  ¿Cuáles?
                </label>
                <input
                  style={{ textTransform: "uppercase" }}
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  className="form-control form-control-user"
                  name="declaracion_tributaria"
                  {...register("declaracion_tributaria", {
                    required: true,
                  })}
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                onClick={handleSubmit(onSubmit)}
              >
                Agregar
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default Partners;
